import $ from "jquery";
export function $$(input) {
  if (typeof input === "string") {
    var WC_Shadow = document.querySelector("oo-widget")
      ? document.querySelector("oo-widget").shadowRoot
      : null;

    var element = WC_Shadow ? WC_Shadow.querySelectorAll(input) : input;

    return $(element);
  } else return $(input);
}
export function querySelector(input) {
  if (typeof input === "string") {
    var WC_Shadow = document.querySelector("oo-widget")
      ? document.querySelector("oo-widget").shadowRoot
      : null;
    var element = WC_Shadow
      ? WC_Shadow.querySelector(input)
      : document.querySelector(input);

    return element;
  } else return input;
}
